import store from '@/store';
import isReserhubUnifiedAccountEnabled, {
  getUnifiedAccountFeatureForReserhub,
} from 'utils/isReserhubUnifiedAccountEnabled';
import { isWebView } from 'utils/webview';

/**
 * Whether loyalty widget updates should be ignored in favor of unified account flows.
 * @returns {boolean} True when not in WebView and Reserhub unified account is enabled.
 */
function shouldIgnoreWidgetUpdate() {
  const state = store.getState();
  const account = state.whitelabelConfig?.env?.reserhub?.account;
  return (
    !isWebView() &&
    isReserhubUnifiedAccountEnabled(account, {
      unifiedAccountFeature: getUnifiedAccountFeatureForReserhub(),
    })
  );
}

export default shouldIgnoreWidgetUpdate;
